import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fbf579c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fbf579c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf579c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbf579c4')) {
      api.createRecord('fbf579c4', component.options)
    } else {
      api.reload('fbf579c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fbf579c4&scoped=true", function () {
      api.rerender('fbf579c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/lead/index.vue"
export default component.exports